import router from "./index";
import cookie from "js-cookie";
import store from "../store";

router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.requireAuth) {
    if (cookie.get("token")) {
      if (store.getters.routers.length === 0) {
        let user = await store.dispatch("getUserInfo");
        store.dispatch("getRouter", user.role_id).then(() => {
          if (store.getters.userRouters.length === 0) {
            next({ name: "errorPage", replace: true });
          } else {
            if (
              to.name === "stack" ||
              store.getters.userRouters.includes(to.meta.key)
            ) {
              next();
            } else {
              next({ name: "errorPage", replace: true });
            }
          }
        });
      } else {
        next();
      }
      next();
    } else {
      store.commit("CLEAR_ROUTER");
      next({ name: "login", query: { redirect: to.fullPath } });
    }
  } else {
    next();
  }
});
